import { LenderClauseTypeValue } from 'api/file/constants';

/**
 * Gets the mortgage clause options based on property state code
 * @param stateCode The state code of the property
 * @returns Array of mortgage clause options
 */
export const getMortgageClause = (stateCode?: string) => {
  const baseMortgageClause = [
    { name: 'Standard', value: 'Standard' },
    { name: 'Successor Ownership', value: 'Successor Ownership' },
    { name: 'FHA', value: 'FHA' },
    { name: 'VA', value: 'VA' },
    { name: 'MERS', value: 'MERS' },
    { name: 'Other', value: 'Other' },
  ];

  // Only show DART option when state is Connecticut
  // If stateCode is undefined, null, or empty string, use default options for safety
  // if (!stateCode) {
  //  console.warn('State code not provided to getMortgageClause, using default options without DART');
  //  return baseMortgageClause;
  // }

  //if (stateCode === 'CT') {
  // return [
  //  ...baseMortgageClause.slice(0, 5), // Insert DART before 'Other'
  //  { name: 'DART', value: 'DART' },
  //  baseMortgageClause[5], // 'Other' option
  // ];

  //}

  return baseMortgageClause;
};

// Default mortgage clause - will be phased out in favor of getMortgageClause
export const mortgageClause = [
  { name: 'Standard', value: 'Standard' },
  { name: 'Successor Ownership', value: 'Successor Ownership' },
  { name: 'FHA', value: 'FHA' },
  { name: 'VA', value: 'VA' },
  { name: 'MERS', value: 'MERS' },
  { name: 'Other', value: 'Other' },
];

export const MortgageClauseTextOptions: Record<string, { name: string; value: string }> = {
  [LenderClauseTypeValue.standard]: {
    value: 'and each successor and/or assign that is defined as an Insured in the Conditions',
    name: 'Standard',
  },
  [LenderClauseTypeValue.successor_ownership]: {
    value: 'and each successor and/or assign that is defined as an Insured in the Conditions of the Policy',
    name: 'SuccessorOwnership',
  },
  [LenderClauseTypeValue.fha]: {
    value:
      'and each successor and/or assign that is defined as an Insured in the Conditions, and THE SECRETARY OF HOUSING AND URBAN DEVELOPMENT, WASHINGTON, D.C.',
    name: 'FHA',
  },
  [LenderClauseTypeValue.va]: {
    value:
      'and each successor and/or assign that is defined as an Insured in the Conditions, and THE SECRETARY OF VETERANS AFFAIRS',
    name: 'VA',
  },
  [LenderClauseTypeValue.mers]: {
    value:
      'appearing of record as MERS, as nominee for {{ COMPANY NAME }}, and each successor and/or assign that is defined as an Insured in the Conditions',
    name: 'MERS',
  },
  [LenderClauseTypeValue.other]: {
    value: '',
    name: 'Other',
  },
};
